import React from "react";
import VariablePicker from "./VariablePicker";

const NEEDS_SINGLE_VAR = new Set(["dv", "groupVar", "var1", "var2"]);

/** Renders the parameter inputs for the currently-selected analysis type. */
function AnalysisParamsForm({ analysisType, dataGroup, variableTypes, values, onChange }) {
  if (!analysisType) return null;

  return (
    <div className="analysis-params-form">
      {analysisType.params.map((p) => {
        if (p.type === "select") {
          return (
            <div className="analysis-form-field" key={p.name}>
              <label>{p.label}</label>
              <select
                className="analysis-select"
                value={values[p.name] ?? p.default}
                onChange={(e) => onChange(p.name, e.target.value)}
              >
                {p.options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
              </select>
            </div>
          );
        }

        if (p.type === "number") {
          return (
            <div className="analysis-form-field" key={p.name}>
              <label>{p.label}</label>
              <input
                type="number"
                className="analysis-number-input"
                value={values[p.name] ?? p.default ?? ""}
                placeholder={p.optional ? "auto" : undefined}
                min={1}
                onChange={(e) => onChange(p.name, e.target.value === "" ? "" : Number(e.target.value))}
              />
            </div>
          );
        }

        // Variable-role picker
        return (
          <div className="analysis-form-field" key={p.name}>
            <label>{p.label}{p.required && <span className="analysis-required">*</span>}</label>
            <VariablePicker
              dataGroup={dataGroup}
              variableTypes={variableTypes}
              role={p.role}
              multiple={p.multiple}
              requireSingleVar={NEEDS_SINGLE_VAR.has(p.name)}
              value={values[p.name]}
              onChange={(val) => onChange(p.name, val)}
            />
          </div>
        );
      })}
    </div>
  );
}

export default AnalysisParamsForm;
